exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd {\n    padding: 15px !important;\n}\n.brk-cart__img {\n    width: 120px !important;\n    height: auto !important;\n}\n", ""]);

// exports
